import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchFavoritedMenus, resetMenus } from '@/actions/menu';
import { fetchFavoritedIdeas, resetIdeas } from '@/actions/idea';
import { fetchFavoritedShoppings, resetShoppings } from '@/actions/shopping';
import useMenuFavoriteList from '@/hooks/useMenuFavoriteList';
import useIdeaFavoriteList from '@/hooks/useIdeaFavoriteList';
import useShoppingFavoriteList from '@/hooks/useShoppingFavoriteList';
import useUser from '@/hooks/useUser';

export default function useFetchFavorite() {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [isFetched, setFetched] = useState(false);
  const menuFavoriteList = useMenuFavoriteList();
  const ideaFavoriteList = useIdeaFavoriteList();
  const shoppingFavoriteList = useShoppingFavoriteList();
  const user = useUser();
  useEffect(() => {
    const fn = () => {
      if (user) {
        !isFetched && setLoading(true);
        Promise.all([
          dispatch(fetchFavoritedMenus(user?.favorited)),
          dispatch(fetchFavoritedIdeas(user?.favorited)),
          dispatch(fetchFavoritedShoppings(user?.favorited))
        ]).then(() => {
          setLoading(false);
          setFetched(true);
        });
      } else {
        dispatch(resetMenus());
        dispatch(resetIdeas());
        dispatch(resetShoppings());
      }
    };
    fn();
  }, [dispatch, isFetched, user]);

  return [menuFavoriteList, ideaFavoriteList, shoppingFavoriteList, isLoading] as const;
}
